import React, { useEffect } from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";
import { useLocation } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";

const FooterPagePro = () => {
  let location = useLocation();

  useEffect(() => { }, [location]);

  return (
    <>
      {!location.pathname.includes("/admin") && (
        <MDBFooter
          color="unique-color-dark"
          className="page-footer font-small pt-0"
        >
          <div style={{ backgroundColor: "#17171f" }}>
            <MDBContainer fluid className="text-center text-md-left">
              <MDBRow className="py-4 d-flex align-items-center">
                <MDBCol
                  md="6"
                  lg="5"
                  className="text-center text-md-left mb-4 mb-md-0"
                >
                  <h6 className="mb-0 white-text">
                    Get connected with me on social networks!
                  </h6>
                </MDBCol>
                <MDBCol md="6" lg="7" className="text-center text-md-right">
                  <a className="fb-ic ml-0">
                    <i className="fab fa-facebook-f white-text mr-lg-4"> </i>
                  </a>
                  <a className="tw-ic">
                    <i className="fab fa-twitter white-text mr-lg-4"> </i>
                  </a>
                  <a className="gplus-ic">
                    <i className="fab fa-google-plus-g white-text mr-lg-4"> </i>
                  </a>
                  <a className="li-ic">
                    <i className="fab fa-linkedin-in white-text mr-lg-4"> </i>
                  </a>
                  <a className="ins-ic">
                    <i className="fab fa-instagram white-text mr-lg-4"> </i>
                  </a>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </div>
          <MDBContainer className="mt-5 mb-4 text-center text-md-left">
            <MDBRow className="mt-3">
              <MDBCol md="4" lg="4" xl="4" className="mb-4">
                <h6 className="text-uppercase font-weight-bold">
                  <strong>ALGO VISUALISER</strong>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px" }}
                />
                <p>Here you can use visualize different sorting algorithms.</p>
              </MDBCol>
              {/* <MDBCol md="2" lg="2" xl="2" className="mb-4">
                <h6 className="text-uppercase font-weight-bold">
                  <strong>Products</strong>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px" }}
                />
                <p>
                  <a href="#!">MDBootstrap</a>
                </p>
                <p>
                  <a href="#!">MDWordPress</a>
                </p>
                <p>
                  <a href="#!">BrandFlow</a>
                </p>
                <p>
                  <a href="#!">Bootstrap Angular</a>
                </p>
              </MDBCol> */}
              <MDBCol md="4" lg="4" xl="4" className="mb-4">
                <h6 className="text-uppercase font-weight-bold">
                  <strong>Useful links</strong>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px" }}
                />
                <p>
                  <a href="/sorting">Sorting</a>
                </p>
                <p>
                  <a href="/path-finding">Path Finding</a>
                </p>
              </MDBCol>
              <MDBCol md="4" lg="4" xl="4" className="mb-4">
                <h6 className="text-uppercase font-weight-bold">
                  <strong>Contact</strong>
                </h6>
                <hr
                  className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto"
                  style={{ width: "60px" }}
                />
                <p>
                  <i className="fa fa-home mr-3" /> Mumbai, Maharashtra, India
                </p>
                <p>
                  <i className="fa fa-envelope mr-3" /> saurabh.kayasth10@gmail.com
                </p>
                <p>
                  <a href="https://www.linkedin.com/in/saurabh-kayasth-684887148">
                    <i className="fab fa-linkedin-in white-text mr-lg-4"> </i>linkedin.com/in/saurabh-kayasth
                  </a>
                </p>
                {/* <p>
                  <i className="fa fa-print mr-3" /> + 01 234 567 89
                </p> */}
              </MDBCol>
            </MDBRow>
          </MDBContainer>
          <div
            className="footer-copyright text-center py-3"
            style={{ backgroundColor: "#17171f" }}
          >
            <MDBContainer fluid>
              &copy; {new Date().getFullYear()} Copyright:{" "}
              <a href="https://www.MDBootstrap.com"> Algo-Visualiser </a>
            </MDBContainer>
          </div>
        </MDBFooter>
      )}
    </>
  );
};

export default FooterPagePro;
